import React, { forwardRef, useRef, useImperativeHandle } from 'react'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { Box } from '@material-ui/core'

export const Form = forwardRef(
    ({ onSubmit, children, schema, defaultValues, className }, ref) => {
        const methods = useForm({
            mode: 'all',
            resolver: yupResolver(schema),
            shouldFocusError: true,
            defaultValues
        })

        const { handleSubmit, setValue } = methods
        const formRef = useRef(null)

        const updateValuesFromDOM = () => {
            const formElement = formRef.current
            if (formElement) {
                const elements = formElement.elements // Get all form controls
                for (let i = 0; i < elements.length; i++) {
                    const element = elements[i]
                    const name = element.name
                    const value = element.value
                    if (name) {
                        setValue(name, value)
                    }
                }
            }
        }

        useImperativeHandle(ref, () => ({
            async submit() {
                updateValuesFromDOM() // Update form state from DOM
                const isValid = await methods.trigger() // Trigger validation
                if (isValid) {
                    methods.handleSubmit(onSubmit)()
                    return true
                }
                return false
            }
        }))

        return (
            <Box
                ref={formRef}
                className={className}
                component="form"
                onSubmit={handleSubmit(onSubmit)}
            >
                {children(methods)}
            </Box>
        )
    }
)
